import { FrameName } from "../config";
import SettlementEmptyTerrainTileEntity from "./SettlementEmptyTerrainTileEntity";

class SettlementEmpty7TerrainTileEntity extends SettlementEmptyTerrainTileEntity {
	public static readonly frameName = FrameName.SETTLEMENT_EMPTY7;
}

export default SettlementEmpty7TerrainTileEntity;
